module.exports = __webpack_public_path__ + "static/media/tulleord-norming-tutorial-2.ed694405.mp3";